<template>
  <div id="my-order">
    <van-icon
      v-show="filterShow"
      @click="goBack"
      class="back-icon"
      size="0.5rem"
      color="#fff"
      name="arrow-left"
    />
    <order-filter
      :type="'tracking'"
      v-show="filterShow"
      @confirm="confirmFilter"
      :is-need-refresh="refresh"
      @refresh="refresh = false"
    ></order-filter>
    <div v-show="!filterShow">
      <router-link tag="div" class="search-bg" to="">
        <img
          @click="filterShow = true"
          src="../../assets/search_03.png"
          alt=""
        />
      </router-link>
    </div>
    <van-tabs
      v-show="!filterShow"
      v-model="index"
      swipeable
      sticky
      :offset-top="45"
    >
      <van-tab :title="'我寄的(' + total[0].votesTotal + '票)'">
        <van-pull-refresh
          v-model="loading"
          style="overflow:unset; padding-bottom: 1.7rem;"
          @refresh="onRefresh"
        >
          <van-list
            :loading="loading"
            :finished="finished[this.index]"
            @load="onLoad"
          >
            <order-item
              :type="'tracking'"
              :to="'/order/waybilldetail?t=true&trackingId=' + item.id"
              v-for="item in sendList"
              :key="item.id"
              :item="item"
            />
          </van-list>
        </van-pull-refresh>
      </van-tab>
      <van-tab :title="'我收的(' + total[1].votesTotal + '票)'">
        <van-pull-refresh
          v-model="loading"
          style="overflow:unset; padding-bottom: 1.7rem;"
          @refresh="onRefresh"
        >
          <van-list
            :loading="loading"
            :finished="finished[this.index]"
            @load="onLoad"
          >
            <order-item
              :type="'tracking'"
              :to="'/order/waybilldetail?t=true&trackingId=' + item.id"
              v-for="item in acceptList"
              :key="item.id"
              :item="item"
            />
          </van-list>
        </van-pull-refresh>
      </van-tab>
    </van-tabs>
    <van-cell v-show="!filterShow" class="total">
      <div class="total-title" slot="icon">
        合计：
      </div>
      <div class="total-row">
        <van-row>
          <van-col span="12"
            >票数：{{ total[this.index].votesTotal }}票</van-col
          >
          <van-col span="12"
            >件数：{{ total[this.index].goodsNumberTotal }}件</van-col
          >
        </van-row>
        <van-row>
          <van-col>运费：{{ total[this.index].freightTotal }}元</van-col>
        </van-row>
      </div>
    </van-cell>
  </div>
</template>
<script>
import { city } from "../../utils/city.js";
import OrderItem from "../../components/OrderItem";
import OrderFilter from "../../components/OrderFilter";

export default {
  name: "WayBill",
  components: {
    OrderItem,
    OrderFilter
  },
  data() {
    return {
      refresh: false,
      // 页码
      pageNum: [1, 1],
      // 是否有下一页
      hasNextPage: [true, true],
      // 发列表
      sendList: [],
      // 收列表
      acceptList: [],
      // 标签页当前索引
      index: 0,
      // 总计数
      total: [
        {
          votesTotal: 0
        },
        {
          votesTotal: 0
        }
      ],
      // 选择器显示
      filterShow: false,
      timeShow: false,
      companyShow: false,
      cityShow: false,
      statusShow: false,
      // 时间选择器
      currentDate: new Date(),
      type: "",
      minDate: new Date(new Date().getFullYear() - 5, 1, 1),
      maxDate: new Date(new Date().getFullYear() + 5, 12, 31),
      startTime: null,
      endTime: null,
      statusText: "请选择状态",
      logisticsCompanyName: "请选择物流公司",
      consigneeCityCode: "请选择目的地站",
      areaId: "440100",
      // 筛选参数
      filterKey: {
        //logisticsCompanyId: this.$logisticsCompanyId,
        consigneeCityCode: "",
        consigneeName: "",
        consigneePhone: "",
        startTime: "",
        endTime: "",
        pullPackWorkerName: "",
        concatPhone: "",
        orderNumber: "",
        trackingNumber: "",
        status: ""
      },
      // 是否正在筛选
      isFilter: false,
      // 物流公司列表
      companyList: [],
      loading: true,
      // 状态列表
      statusList: [
        "",
        "派单中",
        "待提货",
        "拉包中",
        "已开单",
        "短驳运输中",
        "干线待发车",
        "干线运输中",
        "配送中",
        "",
        "已签收",
        "已取消"
      ],
      searching: false,
      // 城市列表
      areaList: city,
      // 已选择状态
      status: [],
      statusCheck: [],
      // 加载是否已完成
      finished: [false, false]
    };
  },
  created() {
    let params = {
      page: {
        pageNum: 1,
        pageSize: 10
      },
      params: {
        flag: 1
        //logisticsCompanyId: this.$logisticsCompanyId
      }
    };
    this.$axios.post("merchant/my_waybill", params).then(res => {
      if (res.data.code === 200) {
        let data = res.data.data;
        this.total[0] = data.params;
        this.sendList = data.list;
        this.loading = false;
        this.hasNextPage[0] = data.hasNextPage;
        this.finished[0] = !data.hasNextPage;
        this.pageNum[0]++;
        params.params.flag = 2;
        this.$axios.post("merchant/my_waybill", params).then(res => {
          if (res.data.code === 200) {
            let data = res.data.data;
            this.total[1] = data.params;
            this.acceptList = data.list;
            this.loading = false;
            this.hasNextPage[1] = data.hasNextPage;
            this.finished[1] = !data.hasNextPage;
            this.pageNum[1]++;
          }
        });
      }
    });
  },
  methods: {
    // 返回按钮
    goBack() {
      if (this.filterShow) {
        this.filterShow = false;
      } else {
        this.$router.go(-1);
      }
    },
    //获取订单列表
    getList(empty) {
      let params, url;
      if (this.index === 0) {
        this.filterKey.flag = 1;
        params = {
          page: {
            pageNum: this.pageNum[this.index],
            pageSize: 10
          },
          params: this.filterKey
        };
        url = "merchant/my_waybill";
      } else {
        this.filterKey.flag = 2;
        params = {
          page: {
            pageNum: this.pageNum[this.index],
            pageSize: 10
          },
          params: this.filterKey
        };
        url = "merchant/my_waybill";
      }
      this.$axios.post(url, params).then(res => {
        if (res.data.code === 200) {
          let data = res.data.data;
          if (empty) {
            if (this.index === 0) {
              this.sendList = data.list;
            } else {
              this.acceptList = data.list;
            }
          } else {
            if (this.index === 0) {
              this.sendList = this.sendList.concat(data.list);
            } else {
              this.acceptList = this.acceptList.concat(data.list);
            }
          }
          this.total[this.index] = data.params;
          this.pageNum[this.index]++;
          this.hasNextPage[this.index] = data.hasNextPage;
          this.loading = false;
          this.finished[this.index] = !data.hasNextPage;
        }
      });
    },
    // 加载列表
    onLoad() {
      this.loading = true;
      this.getList(false);
    },
    // 下拉刷新
    onRefresh() {
      this.searching = false;
      this.pageNum[this.index] = 1;
      this.loading = true;
      Object.keys(this.filterKey).forEach(key => {
        this.$set(this.filterKey, key, "");
      });
      this.getList(true);
      this.refresh = true;
    },
    // 跳转至详情页
    goDetail(orderNumber) {
      this.$router.push("/order/detail?id=" + orderNumber);
    },
    // 跳转至物流查询页
    logisticsSearch(orderNumber) {
      this.$router.push("/search/logistics/" + orderNumber);
    },
    // 确认筛选
    confirmFilter(filterKey) {
      this.searching = true;
      this.pageNum[this.index] = 1;
      this.filterKey = JSON.parse(JSON.stringify(filterKey));
      this.getList(true);
      this.filterShow = false;
    }
  }
};
</script>
<style scoped lang="scss">
#my-order {
  .back-icon {
    position: fixed;
    top: 0;
    left: 0.375rem;
    width: 1rem;
    line-height: 45px;
    z-index: 200;
  }

  .search-bg {
    height: 1rem;
    padding: 0.25rem;

    > img {
      height: 100%;
      width: 100%;
    }
  }

  .total {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    font-size: 0.42rem;
    background-color: #eee;

    .total-title {
      margin-right: 0.25rem;
      color: #f44;
    }
  }

  .card {
    border-bottom: 1px solid #ddd;

    .card-icon {
      padding-top: 0.1rem;
      width: 0.7rem;
      height: 0.7rem;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .card-detail {
      color: #000;
      margin-left: 0.25rem;
      position: relative;

      .detail-btn {
        position: absolute;
        top: 0;
        right: 0;
      }

      .detail-time {
        color: #999;
      }

      .detail-company {
        float: right;
        color: #000;
      }

      .detail-station {
        .station-address {
          color: #999;
        }

        .detail-status {
          position: relative;
          text-align: center;

          .status-text {
            padding: 0.2rem 0;
            margin: 0 auto;
            width: 60%;
            background-color: #ff5454;
            color: #fff;
            border-radius: 0.5rem;
          }

          .detail-icon {
            width: 25%;
            height: 6px;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: 0;
            background-image: url("../../assets/icon_left.png");
            background-size: 100%;
            background-repeat: no-repeat;
            background-position: center;

            &.icon-right {
              right: 0;
              left: unset;
              background-image: url("../../assets/icon_right.png");
            }
          }
        }

        .end-station {
          text-align: right;
        }
      }
    }
  }
}
</style>
